"use strict";

module.exports = function orderedSetParser(input) {
  return new Set(input.split(/\s+/).filter(Boolean));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/helpers/ordered-set-parser.js
// module id = L8Ob
// module chunks = 1